"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("../icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCaretLeft = function FaCaretLeft(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M640 448v896q0 26-19 45t-45 19-45-19L83 941q-19-19-19-45t19-45l448-448q19-19 45-19t45 19 19 45z"
  })));
};

FaCaretLeft.defaultProps = {
  viewBox: '0 0 955.036 1896.083',
  height: '1em',
  width: '0.5037em'
};
FaCaretLeft.displayName = 'FaCaretLeft';
var _default = FaCaretLeft;
exports.default = _default;